import { ReactFormApi, ReactFormExtendedApi } from "@tanstack/react-form";
import { Operator, ProviderType } from "@ternary/api-lib/analytics/enums";
import { Filter } from "@ternary/api-lib/analytics/ui/types";
import {
  BillingRuleType,
  ReallocationType,
} from "@ternary/api-lib/core/types/BillingRule";
import { z } from "zod";

export const filterSchema = z.object({
  displayName: z.string(),
  operator: z.nativeEnum(Operator),
  providerType: z.nativeEnum(ProviderType),
  schemaName: z.string(),
  values: z.array(z.string()),
});

const identifierSchema = z.object({
  labels: z.array(z.object({ key: z.string(), value: z.string() })),
  subAccountID: z.string(),
});

export const staticTargetSchema = z.object({
  identifier: identifierSchema,
  share: z.number(),
});

type Identifier = {
  labels: { key: string; value: string }[];
  subAccountID: string;
};

type StaticTarget = {
  identifier: Identifier;
  share: number;
};

export type MinimalRule = {
  id: string;
  name: string;
  priority: number;
};

export type FormData = {
  adjustToList: boolean;
  applyToAllTenants: boolean;
  applyToTenants: { id: string; name: string }[];
  endDate: Date | null;
  filters: Filter[];
  filtersDynamic: Filter[];
  measure: string | null;
  metrics: string[];
  minimalRules: MinimalRule[];
  minimumShare: number;
  name: string;
  reallocationType: ReallocationType | null;
  rulePriority: { id: string; name: string }[];
  ruleType: BillingRuleType | null;
  setRulePriority: boolean;
  startDate: Date | null;
  targetsStatic: StaticTarget[];
  usageGroupingDimensions: string[];
  value: number;
  weightingKeysSearchText: string;
};

export type SubmitValues = Omit<FormData, "ruleType" | "startDate"> & {
  ruleType: BillingRuleType;
  startDate: Date;
};

export type Form = ReactFormExtendedApi<FormData, undefined> &
  ReactFormApi<FormData, undefined>;
